import CloseIcon from '@mui/icons-material/Close';
import { alpha, Box, Divider, styled, Theme } from '@mui/material';

import { theme } from 'v3/styles/global-styles';

export const Footer = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  gap: '1.5rem',
  padding: '1.5rem',
  width: '100%',
  maxHeight: '100%',
  flexDirection: 'column',

  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row',
    alignItems: 'center',
    maxHeight: '100%',
  },
});

export const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  color: theme.palette.common.white,
  height: ' 100%',
}));

export const Header = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '1.3rem',
  padding: '1rem 1rem 0 1rem',
}));

export const Content = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  overflowY: 'auto',
  padding: '0.2rem',
  flexGrow: 1,
});

export const AlignRowBetween = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  gap: '2rem',
}));

export const List = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  height: 400,
  overflowY: 'auto',
  margin: '1rem',
  gap: '1.5rem',
  borderRadius: '0.75rem',

  '&::-webkit-scrollbar-track': {
    background: theme.palette.secondary.main,
    borderRadius: '0.3125rem',
  },
  '&::-webkit-scrollbar': {
    width: '0.25rem',
  },

  '&::-webkit-scrollbar-thumb': {
    backgroundColor: `${theme.palette.tertiary.light}`,
  },
}));

export const DividerStyled = styled(Divider)(({ theme }) => ({
  borderColor: theme.palette.details.light,

  margin: '0 1rem',
  opacity: 0.5,
}));

export const Item = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  padding: '1.5rem',
  color: theme.palette.common.white,
}));

export const CloseIconStyled = styled(CloseIcon)(({ theme }) => ({
  alignSelf: 'flex-end',
  cursor: 'pointer',
}));

export const dialogStyles = (theme: Theme) => {
  return {
    backgroundColor: theme.palette.primary.main,
    border: `0.1rem solid ${alpha(theme.palette.common.white, 0.4)}`,
    boxShadow: 'none',
    borderRadius: '1rem',
    width: '100%',
    maxWidth: '18.75rem',
    height: '41.563em',

    [theme.breakpoints.up('sm')]: {
      maxWidth: '30rem',
    },
  };
};

export const StoreListInformationContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  textAlign: 'center',

  [theme.breakpoints.up('sm')]: {
    justifyContent: 'start',
    textAlign: 'left',
    maxWidth: '8.125rem',
  },
}));
